module.exports = __webpack_public_path__ + "img/icon-notebook-green-success.96389b76.svg";